import dayjs from 'dayjs';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assets/rh_tooltip_bootstrap.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

import { risenHopeAPIClient } from './api/RisenHopeClient';
import { Environment } from './Environment';
import { persistor, store } from './model/store';
import { LocalLoggingService } from './services/LoggingService';
import { colors } from './modules/core/Styles';
import { LoadingScreen } from './modules/core/LoadingScreen';
import { autoSaveService } from './services/FormAutoSaverService';
import { RhAuthProvider } from './contexts/RhAuthContext';

dayjs.extend(isSameOrAfter);

const startup = () => {
  Environment.set({
    api: risenHopeAPIClient({
      baseURL: process.env.REACT_APP_API_BASE_URL!,
    }),
    services: {
      logger: LocalLoggingService,
      formAutoSaver: autoSaveService(),
    },
  });

  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <React.StrictMode>
          <RhAuthProvider>
            <App />
            <StyledToast
              hideProgressBar={true}
              position="bottom-center"
              style={{ width: 'unset' }}
              closeButton={false}
            />
          </RhAuthProvider>
        </React.StrictMode>
      </PersistGate>
    </Provider>,
    document.getElementById('root')
  );

  reportWebVitals();
};

const StyledToast = styled(ToastContainer).attrs({
  // custom props
})`
  /** Classes for the displayed toast **/
  .Toastify__toast {
    max-height: 60px;
    border-radius: 100px;
    justify-content: center;
    font-family: Nunito;
    font-weight: bold;
    font-size: 18px;
  }
  .Toastify__toast--error {
    background: ${colors.error};
  }
`;

startup();
